const getters = {
  sidebar: state => state.app.sidebar,
  pendingTotal: state => state.app.pendingTotal,
  device: state => state.app.device,
  token: state => state.user.token,
  avatar: state => state.user.avatar,
  name: state => state.user.name,
  roles: state => state.user.roles,
  addRouters: state => state.permission.addRouters,
  routers: state => state.permission.routers,
  visitedViews: state => state.tagsView.visitedViews,
  cachedViews: state => state.tagsView.cachedViews
}
export default getters



// WEBPACK FOOTER //
// ./src/store/getters.js